import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import Select from 'react-select';

import RFReactSelect from './RFReactSelect';
import RolesGroup from './RolesGroup';
import AsyncSelect from 'react-select/lib/Async';
import { isSuperAdmin } from '../../../store/current-user/CurrentUserSelectors';

class UserForm extends React.Component {
  constructor() {
    super();

    this.state = {
      primary: {},
      organizationID: '',
      showSupervised: false,
      showSupervisers: false,
    };
  }

  componentDidMount() {
    const {
      initialValues: { clinics, organizationID },
    } = this.props;
    if (clinics) {
      const primary = clinics.find(clinic => clinic.isPrimary);
      if (primary) {
        this.setState({ primary });
      }
    }
    this.setState({ organizationID: organizationID });
    if (this.props.initialValues.roles) {
      const clinician = this.props.initialValues.roles.find((val) => val.name === 'Clinician');
      const supervisingPhysician = this.props.initialValues.roles.find((val) => val.name === 'Supervising Physician');
      const administrativeProvider = this.props.initialValues.roles.find((val) => val.name === 'Administrative Provider');

      if (clinician) {
        this.setState({ showSupervisers: true });
      }
      else if (administrativeProvider) {
        this.setState({ showSupervised: true });
      }
      else if (supervisingPhysician) {
        this.setState({ showSupervised: true });
      }
    }
  }

  componentWillMount() {
    const {
      initialValues: { organizationID },
    } = this.props;

    this.setState({ organizationID: organizationID });
    this.props.searchClinics(organizationID);
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <input
          {...input}
          className="form-control"
          placeholder={label}
          type={type}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderSelect = ({
    meta: { touched, error, warning },
    label,
    ...allProps
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <RFReactSelect
          {...allProps}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99,
              color: '#108ee9',
            }),
          }}
         />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          key={this.state.organizationID}
          value={input.value}
          cacheOptions
          defaultOptions
          isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.code}
          getOptionLabel={(option) => option.name}
          placeholder="Type Employer Code…"
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99,
              color: '#108ee9',
            })
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientChange = (val) => {
    this.props.change('clients', val);
  }

  searchUsers = (search) => {
    let filters = '';
    if (this.state.showSupervisers) {
      filters = 'isSuperviser';
    }
    return this.props.searchUsers(search, filters, this.state.organizationID);
  }

  searchClients = (search) => {
    return this.props.searchClients(this.state.organizationID, search);
  }

  renderSupervisingSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isMulti
          loadOptions={this.searchUsers}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Type User Name…"
          menuPlacement="top"
            styles={{
              control: styles => ({
                ...styles,
                borderColor: touched && error ? 'red' : '#cccccc',
              }),
              menu: styles => ({
                ...styles,
                zIndex: 99,
                color: '#108ee9',
              }),
            }}
          onChange={this.onSupervisingChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onSupervisingChange = (val) => {
    if (this.state.showSupervised) {
      this.props.change('supervised', val);
    } else {
      this.props.change('supervisers', val);
    }
  }

  renderClinicsSelect = ({
    input,
    options,
    label,
    selected,
    isMulti,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <Select
          {...input}
          options={options}
          value={selected ? selected : input.value}
          isMulti={isMulti}
            styles={{
              control: styles => ({
                ...styles,
                borderColor: touched && error ? 'red' : '#cccccc',
              }),
              menu: styles => ({
                ...styles,
                zIndex: 99,
                color: '#108ee9',
              }),
            }}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderOrgSelect = ({
    input,
    options,
    label,
    selected,
    //isMulti,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <Select
          {...input}
          options={options}
          value={selected ? selected : input.value}
          //isMulti={isMulti}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99,
              color: '#108ee9',
            }),
          }}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onOrgChange = (e, val) => {
    if (val) {
      this.setState({ organizationID: val });
      this.props.change('organizationID', val);
    }

    this.setState({ primary: {} });
    this.props.change('clients', null);
    this.props.searchClients(val, '');
    this.props.change('clinics', null);
    this.props.searchClinics(val);
  };

  orgSelected = () => {
    const { organizationsList } = this.props;
    if (this.state.organizationID) {
      return organizationsList.find(item => item.value === this.state.organizationID);
    }
  };

  onChangePrimaryClinic = (e, val) => {
    const {
      formValues: { clinics },
    } = this.props;
    const primaryClinicIndex = clinics
      ? clinics.findIndex(item => item.isPrimary)
      : -1;
    let newClinics = [];
    if (clinics) {
      newClinics = clinics;
    }
    if (val.value) {
      const primary = { id: val.value, name: val.label, isPrimary: true };
      if (primaryClinicIndex > -1) {
        newClinics.splice(primaryClinicIndex, 1, primary);
      } else {
        newClinics.push(primary);
      }
      this.setState({ primary });
      this.props.change('clinics', newClinics);
    } else {
      if (primaryClinicIndex > -1) {
        newClinics.splice(primaryClinicIndex, 1);
      }
      this.setState({ primary: {} });
      this.props.change('clinics', newClinics);
    }
  };

  onChangeOtherClinics = (e, values) => {
    const {
      formValues: { clinics },
    } = this.props;
    const primaryClinic = clinics ? clinics.find(item => item.isPrimary) : null;
    const newClinics = [];

    if (primaryClinic) {
      newClinics.push(primaryClinic);
    }
    values.forEach(val => {
      newClinics.push({
        id: val.value,
        name: val.label,
      });
    });
    this.props.change('clinics', newClinics);
  };

  primarySelected = () => {
    const { clinicsList } = this.props;
    if (this.state.primary.id) {
      return clinicsList.find(item => item.value === this.state.primary.id);
    }
  };


  otherClinicsSelected = () => {
    const { clinicsList, formValues } = this.props;
    if (formValues && formValues.clinics) {
      const ids = formValues.clinics
        .filter(item => !item.isPrimary)
        .map(item => item.id);
      return clinicsList.filter(item => ids.indexOf(item.value) > -1);
    }
    return [];
  };

  roleChanged = (val) => {
    if (val && val[0].name === 'Clinician') {
      this.setState({ showSupervisers: true });
      this.setState({ showSupervised: false });
    } else if (val && val[0].name === 'Administrative Provider') {
      this.setState({ showSupervised: true });
      this.setState({ showSupervisers: false });
    } else if (val && val[0].name === 'Supervising Physician') {
      this.setState({ showSupervised: true });
      this.setState({ showSupervisers: false });
    } else {
      this.setState({ showSupervised: false });
      this.setState({ showSupervisers: false });

      this.props.change('supervised', []);
      this.props.change('supervisers', []);
    }
  };

  render() {
    const {
      organizationsList,
      clinicsList,
      roles,
      handleSubmit,
      pristine,
      submitting,
      currentUser,
      initialValues,
      isSuperAdmin,
      mode,
      isLoading
    } = this.props;
    const { primary } = this.state;
    const isCurrentUser = initialValues.id === currentUser.id;
    const otherClinicsList = clinicsList.filter(
      clinic => clinic.value !== primary.id,
    );
    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Personal Information</legend>
          <Field
            name="firstName"
            component={this.renderField}
            type="text"
            placeholder="First Name"
            label="First Name"
          />
          <Field
            name="lastName"
            component={this.renderField}
            type="text"
            placeholder="Last Name"
            label="Last Name"
          />
          <Field
            name="email"
            component={this.renderField}
            type="email"
            placeholder="your.email@company.com"
            label="Email"
            disabled={(mode === 'Add') ? false : true}
          />
          <Field
            name="workPhone"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Work Phone"
          />
          <Field
            name="mobilePhone"
            component={this.renderField}
            type="text"
            placeholder="(XXX) XXX-XXXX"
            label="Mobile Phone"
          />
          <Field
            name="title"
            component={this.renderField}
            type="text"
            placeholder="Title"
            label="Title"
          />
        </fieldset>
        <fieldset>
          <legend>Organization Information</legend>
          <Field
            name="organizationID"
            component={this.renderSelect}
            options={organizationsList}
            label="Organization"
            onChange={this.onOrgChange}
            selected={this.orgSelected()}
            disabled={!isSuperAdmin}
          />
          <Field
            name="primaryClinic"
            component={this.renderClinicsSelect}
            options={clinicsList}
            label="Primary Clinic"
            onChange={this.onChangePrimaryClinic}
            selected={this.primarySelected()}
          />
          <Field
            name="otherClinics"
            component={this.renderClinicsSelect}
            options={otherClinicsList}
            isMulti
            label="Other Clinics"
            onChange={this.onChangeOtherClinics}
            selected={this.otherClinicsSelected()}
          />
        </fieldset>
        <fieldset>
          <legend>Client Information</legend>
          <Field
            key={this.state.organizationID}
            name="clients"
            component={this.renderClientsSelect}
            label="Client"
            disabled={!isSuperAdmin}
          />
        </fieldset>
        <fieldset>
          <legend>System Information</legend>
          <div className="form-group">
            <label className="col-md-2 control-label">Roles</label>
            <div className="col-md-10">
              <Field
                name="roles"
                component={RolesGroup}
                options={roles}
                disabled={isCurrentUser}
                onChange={this.roleChanged}
              />
            </div>
          </div>
          <div className="form-group">
            <label className="col-md-2 control-label">Active</label>
            <div className="col-md-10">
              <div className="checkbox">
                <label>
                  <Field
                    name="isActive"
                    component="input"
                    type="checkbox"
                    disabled={isCurrentUser}
                  />
                </label>
              </div>
            </div>
          </div>
          {(mode === 'Add') && (
          <div className="form-group">
            <label className="col-md-2 control-label">External User</label>
            <div className="col-md-10">
              <div className="checkbox">
                <label>
                  <Field
                    name="isLocalUser"
                    component="input"
                    type="checkbox"
                    disabled={isCurrentUser}
                  />
                </label>
              </div>
            </div>
          </div>
          )}
        </fieldset>
        {this.state.showSupervisers &&
          <fieldset>
            <legend>Supervisers</legend>
            <Field
              name="supervisers"
              component={this.renderSupervisingSelect}
              label="Supervising Physicians"
              disabled={!isSuperAdmin}
            />
          </fieldset>
        }
        {this.state.showSupervised &&
          <fieldset>
            <legend>Supervised</legend>
            <Field
              name="supervised"
              component={this.renderSupervisingSelect}
              label="Clinicians"
              disabled={!isSuperAdmin}
            />
          </fieldset>
        }
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
        {isLoading &&
          <div className="cover">
            <div className="spinner inline"></div>
          </div>
        }
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = 'Required';
  }

  if (!values.lastName) {
    errors.lastName = 'Required';
  }

  if (!values.organizationID) {
    errors.organizationID = 'Required';
  }

  if (!values.email) {
    errors.email = 'Required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (values.workPhone && !/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}$/i.test(values.workPhone)) {
    errors.workPhone = 'Invalid phone ex. (XXX) XXX-XXXX';
  }

  if (values.mobilePhone && !/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}$/i.test(values.mobilePhone)) {
    errors.mobilePhone = 'Invalid phone ex. (XXX) XXX-XXXX';
  }

  //if (!values.clinics) {
  //  errors.primaryClinic = 'Required';
  //} else if (!values.clinics.some((clinic) => clinic.isPrimary)) {
  //  errors.primaryClinic = 'Required';
  //}
  return errors;
};

UserForm = connect(state => ({
  formValues: getFormValues('user')(state),
  enableReinitialize: true,
  currentUser: state.currentUser.data,
  isSuperAdmin: isSuperAdmin(state),
  validate: validate,
}))(reduxForm({ form: 'user' })(UserForm));
export default UserForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/UserForm.js